import classNames from 'classnames';
import React from 'react';

import { Tag as TagFromDS } from '@sravni/react-design-system';
import { TagProps } from '@sravni/react-design-system/lib/Tag';

import styles from './tag.module.scss';

export interface ITagProps extends TagProps {
  disabled?: boolean;
  error?: boolean;
}

export const Tag = ({ disabled = false, children, error = false, ...props }) => {
  return (
    <TagFromDS
      className={classNames(styles.tag, {
        [styles['tag--disabled']]: disabled,
        [styles['tag--error']]: error,
      })}
      size={36}
      {...props}
    >
      {children}
    </TagFromDS>
  );
};
